import platformUtils from '../platformUtils';

function extractModelDataFromSrc(src) {
  const mediaSrcHandler = platformUtils.getMediaSrcHandler();
  const parseMediaItem = mediaSrcHandler.parseMediaSrc(
    src,
    mediaSrcHandler.types.AUDIO
  );
  if (parseMediaItem.error) {
    return null;
  }

  return {
    mediaId: parseMediaItem.mediaId,
    duration: parseMediaItem.duration,
    title: parseMediaItem.title
  };
}

export default {
  extractModelDataFromSrc
};
